import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Busyable } from 'src/app/shared/editors/busyable';
import { ApiServiceBase } from 'src/app/Services/api.service.base';

@Component({
  selector: 'app-valetkeyauditdetails',
  templateUrl: './valetkeyauditdetails.component.html',
  styleUrls: ['./valetkeyauditdetails.component.scss'],
  standalone: false
})
export class ValetKeyAuditDetailsComponent extends Busyable implements OnInit {
  public ModelId: any;
  public Model: any;

  constructor(private apiService: ApiServiceBase, private parentRoute: ActivatedRoute, public router: Router) {
    super();
  }

  ngOnInit(): void {
    //fetch inside the params subscription so navigating between audit ids reloads the model
    this.parentRoute.params.subscribe(params => {
      this.ModelId = params['id'];
      this.Loading();
      this.apiService.Get<any>("valet/keyaudits/" + this.ModelId).then(result => {
        this.Model = result;
        this.StopLoading();
      }, () => {
        this.StopLoading();
      });
    });
  }
}
